import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import ReportsWrapper from './components/ReportsWrapper.vue';
import Index from './Index.vue';

import AgentReportsIndex from './AgentReportsIndex.vue';
import InboxReportsIndex from './InboxReportsIndex.vue';
import TeamReportsIndex from './TeamReportsIndex.vue';
import LabelReportsIndex from './LabelReportsIndex.vue';

import AgentReportsShow from './AgentReportsShow.vue';
import InboxReportsShow from './InboxReportsShow.vue';
import TeamReportsShow from './TeamReportsShow.vue';
import LabelReportsShow from './LabelReportsShow.vue';

import CsatResponses from './CsatResponses.vue';
import BotReports from './BotReports.vue';
import LiveReports from './LiveReports.vue';
import SLAReports from './SLAReports.vue';
import KanbanReports from './KanbanReports.vue';
import IntegrationEventsReport from './IntegrationEventsReport.vue';
import CampaignReports from './CampaignReports.vue';
import AiReports from './AiReports.vue';
import VoipReports from './VoipReports.vue';
import ReportsHomeEntry from './ReportsHomeEntry.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'report_manage'],
};

// Lista de flags: a rota so abre com todas ligadas (ver
// accounts/isFeatureEnabledonAccount).
const SLA_REPORT_FLAGS = Object.freeze([
  FEATURE_FLAGS.REPORTS,
  FEATURE_FLAGS.SLA,
]);

// Rotas duplicadas antigas (sem link em nenhum menu desde a chegada das
// versoes `*_overview`). Elas continuam existindo so para nao quebrar link
// salvo: redirecionam para a versao nova, que e a que a casa mostra.
const redirectTo = name => to => ({
  name,
  params: to.params,
  query: to.query,
});

const oldReportRoutes = [
  {
    path: 'agent',
    name: 'agent_reports',
    redirect: redirectTo('agent_reports_index'),
  },
  {
    path: 'inboxes',
    name: 'inbox_reports',
    redirect: redirectTo('inbox_reports_index'),
  },
  {
    path: 'label',
    name: 'label_reports',
    redirect: redirectTo('label_reports_index'),
  },
  {
    path: 'teams',
    name: 'team_reports',
    redirect: redirectTo('team_reports_index'),
  },
];

// Decisao 15 (24/09/2026): Pessoas, Caixas, Etiquetas e Times usam o mesmo
// portao das outras telas herdadas (flag REPORTS + permissao). Antes elas
// abriam em conta com relatorios desligados.
const revisedReportRoutes = [
  {
    path: 'agents_overview',
    name: 'agent_reports_index',
    meta,
    component: AgentReportsIndex,
  },
  {
    path: 'agents/:id',
    name: 'agent_reports_show',
    meta,
    component: AgentReportsShow,
  },

  {
    path: 'inboxes_overview',
    name: 'inbox_reports_index',
    meta,
    component: InboxReportsIndex,
  },
  {
    path: 'inboxes/:id',
    name: 'inbox_reports_show',
    meta,
    component: InboxReportsShow,
  },
  {
    path: 'teams_overview',
    name: 'team_reports_index',
    meta,
    component: TeamReportsIndex,
  },
  {
    path: 'teams/:id',
    name: 'team_reports_show',
    meta,
    component: TeamReportsShow,
  },
  {
    path: 'labels_overview',
    name: 'label_reports_index',
    meta,
    component: LabelReportsIndex,
  },
  {
    path: 'labels/:id',
    name: 'label_reports_show',
    meta,
    component: LabelReportsShow,
  },
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: ReportsWrapper,
      children: [
        {
          // A casa resolve a primeira aba que a pessoa pode ver (ReportsWrapper).
          // O redirect fixo para a visao geral mandava quem nao tem a flag
          // REPORTS para uma tela que o roteador ia recusar em seguida.
          path: '',
          name: 'reports_home',
          meta: {
            permissions: ['administrator', 'agent', 'report_manage'],
          },
          component: ReportsHomeEntry,
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          meta,
          component: LiveReports,
        },
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta,
          component: Index,
        },
        ...oldReportRoutes,
        ...revisedReportRoutes,
        {
          path: 'sla',
          name: 'sla_reports',
          // SLA exige a flag de relatorios E a do proprio SLA: conta sem SLA
          // nao tem politica nenhuma para medir.
          meta: { ...meta, featureFlag: SLA_REPORT_FLAGS },
          component: SLAReports,
        },
        {
          path: 'csat',
          name: 'csat_reports',
          meta,
          component: CsatResponses,
        },
        {
          path: 'bot',
          name: 'bot_reports',
          meta,
          component: BotReports,
        },
        {
          path: 'kanban',
          name: 'kanban_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
            featureFlag: 'kanban_board',
          },
          component: KanbanReports,
        },
        {
          path: 'integration-events',
          name: 'integration_events_report',
          meta: {
            permissions: ['administrator', 'agent', 'report_manage'],
          },
          component: IntegrationEventsReport,
        },
        {
          // Campanhas de WhatsApp: a tela saiu de dentro da configuracao da
          // caixa e ganhou seletor de caixa. A aba antiga aponta para ca.
          path: 'campanhas',
          name: 'campaign_reports',
          meta: {
            permissions: ['administrator'],
          },
          component: CampaignReports,
        },
        {
          path: 'ia',
          name: 'ai_reports',
          meta: {
            permissions: ['administrator'],
            featureFlag: FEATURE_FLAGS.CAPTAIN_V2,
          },
          component: AiReports,
        },
        {
          path: 'ligacoes',
          name: 'voip_reports',
          meta: {
            permissions: ['administrator', 'agent', 'voip_view'],
            featureFlag: FEATURE_FLAGS.VOIP_CALLS,
          },
          component: VoipReports,
        },
      ],
    },
  ],
};
